import React from 'react';
import FinishUploadButtonComponent from './finish-upload-button.component';

function FinishUploadButton(props) {
    return <FinishUploadButtonComponent {...props} />;
}

export default FinishUploadButton;
